<!-- 礼品券 -->
<template>
  <div style="height:100%">
    <van-tabs @click="check_tab">
      <van-tab title="待核销"  name="writeOff"></van-tab>
      <van-tab title="已核销"  name="writeOn"></van-tab>
      <van-tab title="已失效"  name="lostt"></van-tab>
    </van-tabs>
    <div class="body" :is='active'></div>
    <!-- <van-action-sheet v-model="ifshow" :actions="actions" cancel-text="取消" close-on-click-action/> -->

    <!-- 引入子组件 -->
    <!-- <recodes ref="recodes"/> -->
  </div>
</template>

<style lang="scss" scoped>
  .inte_title {
    font-size:15px;
    line-height:44px;
    padding-left:20px;
    background:#fff;
  }

  .body {
    border: 0;
    height: calc(100vh - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    background: #eee;
  }

  .van-cell__title {
    font-size: 15px;
  }

  .num {
    font-size: 18px;
  }
</style>

<script>
import writeOff from './write_off'
import writeOn from './write_on'
import lostt from './lostt'

export default {
  name: 'inte_store',
  components: {writeOff, writeOn, lostt},
  data () {
    return {
      data: [],
      active: 'writeOff',
      ifshow: false,
      actions: [{type: 'writeOff', name: '待核销'}]
    }
  },
  methods: {
    my_mounted () {
      this.$root.loadingAll = false
    },

    // 切换
    check_tab (val) {
      this.active = val
    }

    // 点击选择
    // select (val) {
    //   if (val.type === 'recodes') {
    //     this.$refs.recodes.show()
    //     this.ifshow = true
    //   }
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/gift/index.vue